import * as AC from './actionTypes';

export const getEntrances = (filters = {}) => ({
  type: AC.GET_ENTRANCES_REQUEST,
  filters,
});

export const getEntrancesByBuilding = (buildingId, filters = {}) => ({
  type: AC.GET_BUILDING_ENTRANCES_REQUEST,
  buildingId,
  filters,
});

export const getEntranceDetails = id => ({
  type: AC.GET_ENTRANCE_DETAILS_REQUEST,
  id,
});

export const addEntrance = (name, buildingId) => ({
  type: AC.ADD_ENTRANCE_REQUEST,
  payload: {
    name,
    buildingId,
  },
});

export const editEntrance = (name, buildingId, id) => ({
  type: AC.EDIT_ENTRANCE_REQUEST,
  payload: {
    name,
    buildingId,
    id,
  },
});

export const deleteEntrance = id => ({
  type: AC.DELETE_ENTRANCE_REQUEST,
  id,
});
